import { Button, Card, CardBody, Image } from "@heroui/react";
import '../App.css';
import React from 'react';
import { SignInButton } from "../components/MsalComponents/SignInButton";
import { useMsal } from '@azure/msal-react'
import { InteractionStatus } from '@azure/msal-browser'



const Login = () => {

    const { instance, inProgress } = useMsal()

    const handleLogin = () => {
      // A click while MSAL is still starting up or finishing a redirect throws
      // interaction_in_progress; wait for it instead.
      if (inProgress !== InteractionStatus.None) return;
      console.log('instance', instance)
      instance?.loginRedirect({
      scopes: ['User.Read'],
    })
    }

    return (
    <div className="flex flex-col justify-center items-center h-screen">
      <Card className="w-full max-w-sm  max-h-md">
        <CardBody>
          <div className=" bg-transparent ps-4 pt-4 mb-6">
            <img src="/logo-pdg.svg" alt="Logo" className="w-full ps-1 pe-5 w-auto" />
          </div>
          <Button onPress={handleLogin} isDisabled={inProgress !== InteractionStatus.None} className="w-full">
            Login with Microsoft
          </Button>
        </CardBody>
      </Card>
    </div>
    )
}

export default Login;